import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import React, { ReactNode } from 'react';
import IconMessenger from '@/assets/logos/socialMedia/messenger.svg';
import IconLinkedIn from '@/assets/logos/socialMedia/linkedin-colored-light.svg';
import IconWhatsApp from '@/assets/logos/socialMedia/whatsApp.svg';
import IconX from '@/assets/logos/socialMedia/X.svg';
import { Button } from '@/components/buttons';
import { SHARE_LINKS } from '@/constants/links';
export function Share(t0) {
  const $ = _c(45);
  const {
    url
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["career"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const currentUrl = `${process.env.NEXT_PUBLIC_BASE_URL}${url}`;
  let t2;
  if ($[1] !== t) {
    t2 = t("detail.share");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <h3 className="mb-3 text-center font-semibold">{t2}</h3>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== currentUrl) {
    t4 = SHARE_LINKS(currentUrl);
    $[5] = currentUrl;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = t4.messenger;
  let t6;
  if ($[7] !== t) {
    t6 = t("detail.share");
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = `Facebook messenger: ${t6}`;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IconMessenger className="h-8 w-8" />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t4.messenger || $[11] !== t7) {
    t9 = <Button testId="shareMessenger" analyticsParam="shareMessenger" to={t5} target="_blank" variant="unstyled" ariaLabel={t7}>{t8}</Button>;
    $[10] = t4.messenger;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== currentUrl) {
    t10 = SHARE_LINKS(currentUrl);
    $[13] = currentUrl;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = t10.linkedIn;
  let t12;
  if ($[15] !== t) {
    t12 = t("detail.share");
    $[15] = t;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = `LinkedIn: ${t12}`;
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <IconLinkedIn className="h-8 w-8" />;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t10.linkedIn || $[19] !== t13) {
    t15 = <Button testId="shareLinkedIn" analyticsParam="shareLinkedIn" to={t11} target="_blank" variant="unstyled" ariaLabel={t13}>{t14}</Button>;
    $[18] = t10.linkedIn;
    $[19] = t13;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== currentUrl) {
    t16 = SHARE_LINKS(currentUrl);
    $[21] = currentUrl;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  const t17 = t16.x;
  let t18;
  if ($[23] !== t) {
    t18 = t("detail.share");
    $[23] = t;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  const t19 = `X: ${t18}`;
  let t20;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <IconX className="h-8 w-8 text-blue-500" />;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  let t21;
  if ($[26] !== t16.x || $[27] !== t19) {
    t21 = <Button testId="shareX" analyticsParam="shareX" to={t17} target="_blank" variant="unstyled" ariaLabel={t19}>{t20}</Button>;
    $[26] = t16.x;
    $[27] = t19;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== currentUrl) {
    t22 = SHARE_LINKS(currentUrl);
    $[29] = currentUrl;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  const t23 = t22.whatsApp;
  let t24;
  if ($[31] !== t) {
    t24 = t("detail.share");
    $[31] = t;
    $[32] = t24;
  } else {
    t24 = $[32];
  }
  const t25 = `WhatsApp: ${t24}`;
  let t26;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <IconWhatsApp className="h-8 w-8" />;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  if ($[34] !== t22.whatsApp || $[35] !== t25) {
    t27 = <Button testId="shareWhatsApp" analyticsParam="shareWhatsApp" to={t23} target="_blank" variant="unstyled" ariaLabel={t25}>{t26}</Button>;
    $[34] = t22.whatsApp;
    $[35] = t25;
    $[36] = t27;
  } else {
    t27 = $[36];
  }
  let t28;
  if ($[37] !== t15 || $[38] !== t21 || $[39] !== t27 || $[40] !== t9) {
    t28 = <div className="flex items-center justify-center gap-5">{t9}{t15}{t21}{t27}</div>;
    $[37] = t15;
    $[38] = t21;
    $[39] = t27;
    $[40] = t9;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  if ($[42] !== t28 || $[43] !== t3) {
    t29 = <div>{t3}{t28}</div>;
    $[42] = t28;
    $[43] = t3;
    $[44] = t29;
  } else {
    t29 = $[44];
  }
  return t29;
}